<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="550px">
      <v-card>
        <v-card-title class="InsertTitle">
          <v-toolbar color="primary" dark>ユーザ選択</v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-form ref="p1DialogForm" v-model="valid" lazy-validation>
            <v-container>
              <v-row>
                <ryou-table
                  ref="ryouTablePop"
                  :rowKey="rowKey"
                  :title="'ユーザ選択一覧'"
                  :headers="headers"
                  :url="popUrl"
                  :showSelect="true"
                  :singleSelect="false"
                  :businessKey="businessKey"
                  :autoLoad="false"
                  :dummy="false"
                  class="InsertTitle1"
                  :needSearch="true" 
                >
                </ryou-table>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <ryou-black-btn
            :label="'閉じる'"
            :handlerClick="handleCancel"
            :iconCls="'mdi-close'"
          >
          </ryou-black-btn>
          <v-spacer></v-spacer>
          <ryou-black-btn
            :label="'設定'"
            :handlerClick="handleOk"
          ></ryou-black-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import RyouTable from "@/components/table/RyouTable.vue";
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";

import { RyouTableMixins } from "@/mixins/RyouTableMixins";

export default {
  mixins: [RyouTableMixins],
  components: {
    RyouBlackBtn,
    RyouTable,
  },
  mounted() {
    this.inputRules.push(this.GlobalRules.required);
  },
  props: {
    url: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data: () => ({
    dialog: false,
    title: "",
    valid: true,
    inputRules: [],
    rowKey: "rowIndex",
    businessKey: "user_id",
    popUrl: {
      originlist: "/noticeRegistration/buildGroupTenantGet/",
      list: "/noticeRegistration/buildGroupTenantGet/",
    },
    tableName: "ryouTablePop",
    headers: [
      {
        text: "社員番号",
        value: "user_id",
        width: "130",
        sortable: true,
        groupable: false,
      },
      {
        text: "氏名",
        value: "user_name",
        width: "130",
        sortable: false,
        groupable: false,
      },
      {
        text: "所属",
        value: "affiliation",
        width: "140",
        sortable: false,
        groupable: false,
      },
    ],
  }),

  methods: {
    selectUsers() {
      this.open();
      this.title = "ユーザ選択";
    },
    handleCancel() {
      this.close();
    },
    handleOk() {
      // グリッドによって選択された結果セットをループさせると、親画面のデータを返します

      var tempId = "";
      var tempName = "";
      this.selectionRows.forEach((item) => {
        tempId += item.user_id + "/";
        tempName += item.user_name + "\r\n";
      });
      var arr = [tempId, tempName];
      this.$emit("setDataByChild", arr);
      this.close();
    },
    close() {
      this.$refs.ryouTablePop.selected = [];
      this.dialog = false;
    },
    open() {
      this.dialog = true;

      var that = this;
      setTimeout(() => {
        // // ポップアップ画面でグリッド検索のURLを変更します
        // that.$refs.ryouTablePop.url.list += localStorage.getItem("info_seq_no");

        that.$refs.ryouTablePop.$on(
          "getSelectedRowKeys",
          this.getSelectedRowKeys
        );
        that.$refs.ryouTablePop.url.list =
          that.popUrl.originlist +
          this.$store.getters.getUserId +
          "/" +
          this.$store.getters.getUserClass;
        // ポップアップ画面でグリッド検索処理を行う
        that.$refs.ryouTablePop.loadData();
      }, 10);

      if (this.$refs.p1DialogForm) {
        this.$refs.p1DialogForm.reset();
        this.$refs.p1DialogForm.resetValidation();
      }
    },
  },
};
</script>

<style scoped>
.InsertTitle {
  padding: 0px 0px 12px !important;
}
.InsertTitle1 {
  padding: 5px 0px 0px 0px;
}
</style>